import { Component, Vue } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import { getMessageReviewById } from '@/api/message'
import { setFinanceBackMoneyStatus, getTransactionNumberSum  } from '@/api/financial-center'

import * as math from 'mathjs'
import {makeUploadSignature} from "@/utils/uploadMd5";

@Component({})
export default class BackMoneyStudentInfo extends Vue {
    logShow = true
    backMoneyId = NaN
    backMoneyInfo: any = ''
    type = ''

    cancleReview = false
    reviewDialog = false
    opinion = '' // 审批意见
    status: number = null // 提交时候用到的状态
    reviewStatus: string = null //审批状态
    editFileList = []
    editFiles = {
        account: null,
        payAccount: null, // 付款账户
        backMoneyAt: null,
        financeBackMoneyProofList: null,
        transactionNumber: null,// 流水号
    }
    isRequired = false
    previewVisible = false
    previewPath = ''
    disBtn = false
    fileList: { name: string; url: string; uid?: number }[] = []
    types = ''
    // 2023-2-23新增
    approvalVisible = false
    nodeType: string = null //驳回到哪个节点
    stepNode = {
        isFirstNode: false,
        isSyncEkuaibao: false,
        isSyncEqianbao: false,
    }
    addSignShow = false
    transferShow = false
    previewName = ''
    approvedVisible = false // 审批通过
    approvedData = {}
    isAgreeRevoke = '' // 审批通过是否允许提交人撤回
    loading = false
    isNotReject = false
    uploadData = {
        bucket: 'crm',
        signature: ''
    }
    repeatMoney = 0  // 重复流水号对应的已填报回款金额
    isTransactionNumberRepeat = false // 流水号是否重复

    get orderAllPrice() {
        let num = 0
        if(this.backMoneyInfo) this.backMoneyInfo.financeBackMoneyDetailList.forEach(item =>
        {
            num = math.number(math.add(math.bignumber(num),math.bignumber( Number(item.price))))
        }
        )
        return num
    }

    get needBackMoney() {
        let num = 0
        if(this.backMoneyInfo) this.backMoneyInfo.financeBackMoneyDetailList.forEach(item => {
            num = math.number(math.add(math.bignumber(num),math.bignumber(Number(item.needBackMoney))))
            }
        )
        return num
    }

    get thisBackMoney() {
        let num = 0
        if(this.backMoneyInfo) this.backMoneyInfo.financeBackMoneyDetailList.forEach(item =>{
            num = math.number(math.add(math.bignumber(num),math.bignumber(Number(item.thisTimePrice))))
            }
        )
        return num
    }

    get elImageUrls() {
        return this.backMoneyInfo ? this.backMoneyInfo.financeBackMoneyProofList.map(item => item.url): []
    }
    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }

    created() {
        this.backMoneyId = Number(this.$route.query.id)
        this.types = this.$route.query.types ? this.$route.query.types as string : ''
        this.getFinanceBackMoneyById()
        this.type = this.$route.query.type as string
        this.reviewStatus = this.$route.query.status as string
    }

    formatDate = formatDate

    beforeUpload (file) {
        // 1. 为当前文件实时生成专属 signature，并同步更新全局 uploadData
        const currentSignature = makeUploadSignature('crm', file.name);
        // this.uploadData.signature = currentSignature; // 同步更新，立即生效
        this.$set(this.uploadData, 'signature', currentSignature);
    }


    async getFinanceBackMoneyById() {
        this.loading = true
        await getMessageReviewById(this.backMoneyId, this.types).then((data: any) => {
            this.backMoneyInfo = data.result
            this.isNotReject = data.result.isNotReject == true ? false : true
            this.editFileList = this.backMoneyInfo.editFileList
            this.editFileList && this.editFileList.forEach(item => {
                this.editFiles[item.file] = this.backMoneyInfo[item.file]
            })
            this.fileList = this.backMoneyInfo.financeBackMoneyProofList
            if (this.editFileList && this.editFileList.length > 0) this.isRequired = this.type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填
            this.stepNode.isFirstNode = this.backMoneyInfo.isFirstNode
            this.stepNode.isSyncEkuaibao = this.backMoneyInfo.isSyncEkuaibao
            this.stepNode.isSyncEqianbao = this.backMoneyInfo.isSyncEqianbao
            this.loading = false
        }).catch(err => {
            this.loading = false
        })
    }

    // 验证当前字段是否可以编辑
    editFileShow(key: string) {
        if (this.reviewStatus !== '0' || this.type !== '0') return false
        if(this.editFileList != undefined && this.editFileList != null){
            return this.editFileList.some(item => item.file === key)
        }
    }

    uploadSuccess(response, file, fileList) {
        // const { data } = res
        // this.$message.success('上传成功')
        // this.fileList.push({ name: data.name, url: data.ossUrl })
        if (fileList.every(item => item.status == 'success')) {
            this.editFiles.financeBackMoneyProofList = fileList.map(item => {
                if (item.status == 'success') {
                    return {
                        name: item.name,
                        url: item.url ? item.url : item.response.data.ossUrl
                    }
                }
            });
            this.$message.success('上传成功');
            // 手动触发 Vue 更新
            this.$forceUpdate();
        }
    }
    uploadError() {
        this.$message.error('上传失败')
    }
    handleUploadRemove(file) {
        this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    }

    handlePreview(file) {
        this.previewPath = file.url
        this.previewName = file.name
        this.previewVisible = true
    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }

    // 撤回审批
    async cancleReviewDialogConfirm() {
        await setFinanceBackMoneyStatus({ id: this.backMoneyInfo.id, action: '1' })
        this.$message.success('成功撤回审批')
        setTimeout(() => { window.close() }, 1500)
    }

    openReviewDialog(status: number) {
        // 传入组件的值
        this.$set(this.approvedData, 'status', status)
        this.$set(this.approvedData, 'editFiles', this.editFiles)
        this.$set(this.approvedData, 'editFileList', this.editFileList)
        this.$set(this.approvedData, 'isRequired', this.isRequired)
        this.$set(this.approvedData, 'approveId', this.backMoneyId)
        this.approvedVisible = true
    }

    // 关闭审批弹窗
    closeReviewDialog() {
        this.reviewDialog = false
        this.opinion = ''
    }


    // 驳回审批
    clickRejectButton(status: number) {
        // 传入组件的值
        this.$set(this.stepNode, 'status', status)
        this.$set(this.stepNode, 'approveId', this.backMoneyId)
        this.approvalVisible = true
    }

    //     关闭审批弹框
    handleApprovalClose() {
        this.approvalVisible = false
    }

//    驳回弹框确认
    doApprovalConfirm(data) {
        this.approvalVisible = false
    }

    /*
  * 关闭转交弹框*/
    closeTransfer() {
        this.transferShow = false
    }

    /*
    * 转交弹框确认*/
    confirmTransfer() {
        this.transferShow = false
    }

    /*
    * 关闭加签*/
    closeAddSign() {
        this.addSignShow = false
    }

    /*
    * 确认加签*/
    confirmAddSign() {
        this.addSignShow = false
    }

    // 审批通过弹框取消
    handleApprovedClose(){
        this.approvedVisible = false
    }
    // 审批通过弹框确认
    doApprovedConfirm(data) {
        //     关闭弹框
        this.approvedVisible = false
    }

//确认流水号是否重复（输入即校验：防抖 + 竞态控制）
    private transactionCheckTimer: any = null
    private transactionCheckSeq = 0

    inputBankTransactionNo() {
        if (this.transactionCheckTimer) clearTimeout(this.transactionCheckTimer)
        const seq = ++this.transactionCheckSeq
        this.transactionCheckTimer = setTimeout(async () => {
            const transactionNumber = this.editFiles.transactionNumber
            if (!transactionNumber) {
                if (seq === this.transactionCheckSeq) this.isTransactionNumberRepeat = false
                return
            }
            try {
                const data: any = await getTransactionNumberSum(transactionNumber)
                if (seq !== this.transactionCheckSeq) return
               
                if (data != null && data !== '') {
                    if (data.transactionNumberSum > 0) {
                        this.isTransactionNumberRepeat = true
                        this.repeatMoney = data.transactionNumberSum
                    } else {
                        this.isTransactionNumberRepeat = false
                    }
                } else {
                    this.isTransactionNumberRepeat = false
                }
            } catch (e) {
                if (seq === this.transactionCheckSeq) this.isTransactionNumberRepeat = false
            }
        }, 500)
    }
}
